import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import PrivateRoute from './components/PrivateRoute.jsx';
import Layout from './components/Layout.jsx';
import AdminLayout from './components/AdminLayout.jsx';
import ErrorBoundary from './components/ErrorBoundary.jsx';
import Toast from './components/ui/Toast.jsx';
import Home from './pages/Home.jsx';
import Confirmacion from './pages/Confirmacion.jsx';
import Login from './pages/Login.jsx';
import AdminInvitados from './pages/admin/AdminInvitados.jsx';
import AdminEvento from './pages/admin/AdminEvento.jsx';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: 'confirmacion/:token', element: <Confirmacion /> },
      { path: 'login', element: <Login /> },
    ],
  },
  {
    path: '/admin',
    element: <PrivateRoute />,
    children: [
      {
        element: <AdminLayout />,
        children: [
          { index: true, element: <AdminInvitados /> },
          { path: 'evento', element: <AdminEvento /> },
        ],
      },
    ],
  },
]);

export default function App() {
  return (
    <ErrorBoundary>
      <RouterProvider router={router} />
      <Toast />
    </ErrorBoundary>
  );
}

export { router };
